import type { I18nT } from '@runtime/core/i18n/i18n'

import arghCharacterSrc from '@/assets/characters/argh.png'
import coachCharacterSrc from '@/assets/characters/coach.png'
import detectiveCharacterSrc from '@/assets/characters/detective.png'
import girlCharacterSrc from '@/assets/characters/girl.png'

// Centralized definition for help characters (icons/avatars used in help modals and tooltips).
export const HELP_CHARACTERS = {
  coach: {
    id: 'coach',
    img: coachCharacterSrc,
    altKey: 'helpCharacters.coachAlt',
  },
  detective: {
    id: 'detective',
    img: detectiveCharacterSrc,
    altKey: 'helpCharacters.detectiveAlt',
  },
  argh: {
    id: 'argh',
    img: arghCharacterSrc,
    altKey: 'helpCharacters.arghAlt',
  },
  girl: {
    id: 'girl',
    img: girlCharacterSrc,
    altKey: 'helpCharacters.girlAlt',
  },
} as const

export type HelpCharacterKey = keyof typeof HELP_CHARACTERS

export function getHelpCharacter(key: string) {
  return key in HELP_CHARACTERS ? HELP_CHARACTERS[key as HelpCharacterKey] : HELP_CHARACTERS.coach
}

export function getHelpCharacterAlt(t: I18nT, key: string) {
  const character = getHelpCharacter(key)
  return t(character.altKey)
}
